import { createFeature, createReducer, on } from '@ngrx/store';
import { CompanyListActions } from './company-list.actions';
import { CompanyListFeatureState } from './company-list.models';

export const initialCompanyListState: CompanyListFeatureState = {
  filters: {
    companyName: null,
    cityId: null,
    cityFilterLabel: null,
    stateId: null,
    industryTypeId: null,
    industryTypeFilterLabel: null,
    sourceId: null,
    sourceFilterLabel: null,
    flameLevelId: null,
    isBlacklistCompany: false
  },
  pagination: {
    firstRowOffset: 0,
    pageSize: 10,
    page: 1,
    totalRecords: 0
  },
  sort: {
    sortField: null,
    sortOrder: 1,
    previousSortField: '',
    previousSortOrder: 0
  },
  gridData: null
};

const reducer = createReducer(
  initialCompanyListState,
  on(CompanyListActions.snapshotPersisted, (state, { snapshot }) => ({
    ...state,
    filters: snapshot.filters,
    pagination: snapshot.pagination,
    sort: snapshot.sort
  })),
  on(CompanyListActions.gridDataCached, (state, { gridData }) => ({
    ...state,
    gridData
  })),
  on(CompanyListActions.gridDataCleared, (state) => ({
    ...state,
    gridData: null
  })),
  on(CompanyListActions.cleared, () => initialCompanyListState)
);

export const companyListFeature = createFeature({
  name: 'companyList',
  reducer
});
